module.exports = __webpack_public_path__ + "img/user-interface-logo.8d8e63f6.png";